module.exports = __webpack_public_path__ + "img/draw-hand.aa427b90.png";